import { render, staticRenderFns } from "./Debug.vue?vue&type=template&id=af438e26&scoped=true&"
import script from "./Debug.vue?vue&type=script&lang=js&"
export * from "./Debug.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af438e26",
  null
  
)

export default component.exports